import { BaseMessage } from "./baseMessage";

export class GenericMessage extends BaseMessage{
  protected readonly MESSAGE = "message";

  get message(): string { return this.getInternalValue<string>(this.MESSAGE); }
  setMessage(message: string): this { return this.setInternalValue(this.MESSAGE, message); }

}